module.exports = __webpack_public_path__ + "static/media/users-blue.bfe2d36b.svg";